/**
 * Builds the protected funnel topic.
 * @param funnelId - CRM funnel identity.
 * @returns Funnel subscription topic.
 */
export const buildFunnelTopic = (funnelId: number): string =>
  `communications.funnel.${funnelId}`;

/**
 * Builds the protected detail topic.
 * @param conversationId - CRM conversation identity.
 * @returns Conversation subscription topic.
 */
export const buildConversationTopic = (conversationId: number): string =>
  `communications.conversation.${conversationId}`;

const normalizeIds = (ids: (number | undefined)[]): number[] =>
  Array.from(
    new Set(
      ids.filter(
        (id): id is number =>
          typeof id === 'number' && Number.isSafeInteger(id) && id > 0
      )
    )
  ).sort((left, right) => left - right);

/**
 * Normalizes view IDs into a stable dependency key.
 * @param ids - Optional CRM identities.
 * @returns Sorted unique positive safe IDs, joined by commas.
 */
export const buildIdsKey = (ids: readonly (number | undefined)[]): string =>
  normalizeIds([...ids]).join(',');

/**
 * Restores normalized IDs from a stable dependency key.
 * @param key - Normalized ID key.
 * @returns The normalized view identifiers.
 */
export const parseIdsKey = (key: string): number[] =>
  key.length > 0 ? key.split(',').map((id) => Number(id)) : [];
